import axios from "axios"

const instance = axios.create({
    baseURL: "https://planoensinoapi.progm.net.br/",
    timeout: 1000,
    headers: { "X-keyword": "planoEnsino" }
})

export default instance